import { message } from "antd";
import { number } from "prop-types";
const getParamsByMotionType = (currentNode, blocksMap = null) => {
    // console.log("qlog: ", currentNode);
    const type = currentNode.opcode;
    
    // 处理通用输入值（支持shadow block和嵌套block）
    const getInputValue = (inputName, defaultValue = null) => {
        const input = currentNode.inputs?.[inputName];
        if (!input) return defaultValue;
        
        // 情况1：input有fields（直接输入或shadow block）
        if (input.fields?.NUM?.value !== undefined && input.fields.NUM.value !== '') {
            return input.fields.NUM.value;
        }
        if (input.fields?.TEXT?.value !== undefined && input.fields.TEXT.value !== '') {
            return input.fields.TEXT.value;
        }
        
        // 情况2：input本身就是嵌套的积木对象（buildBlockTree已经将嵌套积木转换为对象）
        if (input.opcode) {
            // 这是一个嵌套的积木对象，递归获取它的值
            const nestedResult = getParamsByMotionType(input, blocksMap);
            // 返回一个包含积木类型和参数的对象，方便上层识别
            return {
                blockType: input.opcode,
                ...nestedResult
            };
        }
        
        // 情况3：input有block属性（ID引用），需要从blocksMap查找
        if (input.block && blocksMap) {
            const nestedBlock = blocksMap[input.block];
            if (nestedBlock) {
                const nestedResult = getParamsByMotionType(nestedBlock, blocksMap);
                return {
                    blockType: nestedBlock.opcode,
                    ...nestedResult
                };
            }
        }
        
        // 情况4：input是一个数组结构（shadow block的引用）
        if (Array.isArray(input) && input.length > 0) {
            // 例如: ["event_compare", {"OP": ">"}, ...]
            if (typeof input[0] === 'string') {
                return {
                    blockType: input[0],
                    isShadowBlock: true,
                    value: input
                };
            }
        }
        
        // 如果没有找到值，返回默认值
        return defaultValue;
    };
    
    if (
        [
            "motion_movesteps",
            "motion_forward",
            // "motion_moveleft",
            // "motion_moveright",
        ].includes(type)
    ) {
        return {
            steps: currentNode.inputs.STEPS.fields.NUM.value,
        };
    } else if (type === "motion_turnright" || type === "motion_turnleft") {
        return {
            angle: currentNode.inputs.DEGREES.fields.NUM.value,
        };
    } else if (type === "control_servo_reset") {
        return {
            action: "6",
            step: 1,
        };
    } else if (type === "motion_nod") {
        return {
            action: "3",
            step: 1,
        };
    } else if (type === "motion_sway_x") {
        return {
            action: "7",
            step: 1,
        };
    } else if (type === "motion_sway_y") {
        return {
            action: "9",
            step: 2,
        };
    } else if (type === "motion_fall") {
        return {
            action: "8",
            step: 1,
        };
    } else if (type === "motion_retract_leg") {
        return {
            action: "10",
            step: 1,
        };
    } else if (type === "motion_handshake") {
        return {
            action: "11",
            step: 1,
        };
    } else if (type === "motion_stretch") {
        return {
            action: "12",
            step: 1,
        };
    } else if (type === "motion_jump") {
        return {
            action: "13",
            step: 1,
        };
    } else if (type === "self_dog_move_control") {
        return {
            action: "14",
            step: 1,
        };
    } else if (type === "motion_gotoxy") {
        return {
            pos:
                currentNode.inputs.X.fields.NUM.value +
                "," +
                currentNode.inputs.Y.fields.NUM.value,
        };
    } else if (type === "motion_dance") {
        return {};
    } else if (type === "motion_gotoxyz") {
        return {
            x: currentNode.inputs.X.fields.NUM.value,
            y: currentNode.inputs.Y.fields.NUM.value,
            z: currentNode.inputs.Z.fields.NUM.value,
        };
    } else if (type === "looks_set_rgb") {
        // 设置RGB颜色:支持颜色选择器
        const index = currentNode.fields?.index?.value ?? 1;  // 改为从fields获取
        const colorValue = currentNode.inputs?.color?.fields?.COLOUR?.value || '#ff0000';
        
        // 将十六进制颜色转换为RGB
        const hexToRgb = (hex) => {
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : { r: 255, g: 0, b: 0 };
        };
        
        const rgb = hexToRgb(colorValue);
        
        return {
            index: parseInt(index),  // 转换为数字
            color: colorValue,  // 十六进制颜色值
            r_val: rgb.r,  // R分量
            g_val: rgb.g,  // G分量
            b_val: rgb.b,  // B分量
        };
    } else if (type === "looks_turn_on_all_lights") {
        // 打开所有灯光:支持颜色选择器
        const colorValue = currentNode.inputs?.color?.fields?.COLOUR?.value || '#ff0000';
        
        // 将十六进制颜色转换为RGB
        const hexToRgb = (hex) => {
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : { r: 255, g: 0, b: 0 };
        };
        
        const rgb = hexToRgb(colorValue);
        
        return {
            index: '0xff',
            color: colorValue,  // 十六进制颜色值
            r_val: rgb.r,  // R分量
            g_val: rgb.g,  // G分量
            b_val: rgb.b,  // B分量
        };
    } else if (type === "looks_turn_off_all_lights") {
        // 关闭所有灯光
        return {
            index: '0xfe',
        };
    } else if (type === "looks_show_expression") {
        return {
            emotion: parseInt(currentNode.fields?.expression?.value),
        };
    } else if (type === "image_identify_object") {
        const yesCommands = [];
        const yesCommands2 = [];
        let substackNode = currentNode.inputs?.substack;
        let substackNode2 = currentNode.inputs?.substack2;
        
        while (substackNode) {
            yesCommands.push({
                opcode: substackNode.opcode,
                arguments: getParamsByMotionType(substackNode, blocksMap)
            });
            substackNode = substackNode.next;
        }

        while (substackNode2) {
            yesCommands2.push({
                opcode: substackNode2.opcode,
                arguments: getParamsByMotionType(substackNode2, blocksMap)
            });
            substackNode2 = substackNode2.next;
        }

        // 获取 text 输入的值（支持嵌套积木）
        const textValue = getInputValue('text');
        
        return {
            object: currentNode.fields?.expression?.value,
            text: textValue,  // 支持嵌套积木
            yes: yesCommands,
            no: yesCommands2,
        };
    } else if (type === "event_if_else") {
        console.log("currentNode", currentNode)
        const yesCommands = [];
        const yesCommands2 = [];
        let substackNode = currentNode.inputs?.substack;
        let substackNode2 = currentNode.inputs?.substack2;
        while (substackNode) {
            yesCommands.push({
                opcode: substackNode.opcode,
                arguments: getParamsByMotionType(substackNode, blocksMap)
            });
            substackNode = substackNode.next;
        }

        while (substackNode2) {
            yesCommands2.push({
                opcode: substackNode2.opcode,
                arguments: getParamsByMotionType(substackNode2, blocksMap)
            });
            substackNode2 = substackNode2.next;
        }

        // 获取CONDITION输入的值（支持嵌套积木）
        const conditionValue = getInputValue('CONDITION');
        
        return {
            // object: currentNode.fields?.expression?.value,
            // result: currentNode.inputs?.text?.fields?.TEXT?.value,
            condition: conditionValue,  // 添加条件值
            yes: yesCommands,
            no: yesCommands2,
        };
    } else if(type == "event_if_button" || type == "event_button_pressed"){ //如果[左边/右边]键按下那么
      const yesCommands = [];
      const yesCommands2 = [];
      let substackNode = currentNode.inputs?.substack;
      let substackNode2 = currentNode.inputs?.substack2;
      
      while (substackNode) {
          yesCommands.push({
              opcode: substackNode.opcode,
              arguments: getParamsByMotionType(substackNode, blocksMap)
          });
          substackNode = substackNode.next;
      }

      while (substackNode2) {
            yesCommands2.push({
                opcode: substackNode2.opcode,
                arguments: getParamsByMotionType(substackNode2, blocksMap)
            });
            substackNode2 = substackNode2.next;
        }
      
      return {
          object: currentNode.fields?.button?.value,
          yes: yesCommands,
          no: yesCommands2,
      };
    } else if (type === "looks_theme") {
        return {
            theme: currentNode.fields?.theme?.value,
        };
    } else if (type === "event_repeat") {
        const commands = [];
        let substackNode = currentNode.inputs?.substack;
        
        // Recursively collect all blocks in the substack
        while (substackNode) {
            commands.push({
                opcode: substackNode.opcode,
                arguments: getParamsByMotionType(substackNode)
            });
            substackNode = substackNode.next;
        }
        
        return {
            times: currentNode.inputs?.times.fields?.NUM?.value,
            commands: commands
        };
    } else if (type === "looks_show_text") {
        // 支持嵌套积木和直接文本输入
        const showTextValue = getInputValue('show_text');
        
        return {
            show_text: showTextValue,
            second: currentNode.inputs?.second?.fields?.NUM?.value || 1
        };
    } else if (type === "looks_show_image") {
        
        return {
            url : currentNode?.fields?.IMAGE_DATA?.value+'?x-oss-process=image/resize,m_lfit,h_120,w_120/format,png/quality,Q_40' || null
        };
    } else if (type === "event_interval") {
        const commands = [];
        let substackNode = currentNode.inputs?.substack;
        
        // Recursively collect all blocks in the substack
        while (substackNode) {
            commands.push({
                opcode: substackNode.opcode,
                arguments: getParamsByMotionType(substackNode)
            });
            substackNode = substackNode.next;
        }
        
        return {
            second: currentNode.inputs?.second.fields?.NUM?.value,
            total_times: currentNode.inputs?.total_times.fields?.NUM?.value,
            commands: commands
        };
    } else if (type === "event_compare") {
        // 比较运算符：支持嵌套输入
        const value1 = getInputValue('VALUE1', 0);
        const value2 = getInputValue('VALUE2', 0);
        
        return {
            value1: value1,
            operator: currentNode.fields?.OP?.value || '>',
            value2: value2,
            type: 'compare'
        };
    } else if (type === "event_and_or") {
        // 逻辑运算符：支持嵌套输入
        const value1 = getInputValue('VALUE1', 0);
        const value2 = getInputValue('VALUE2', 0);
        
        return {
            value1: value1,
            operator: currentNode.fields?.OP?.value || 'AND',
            value2: value2,
            type: 'logical'
        };
    } else if (type === "event_repeat_condition") {
        console.log("event_repeat_condition currentNode", currentNode);
        const yesCommands = [];
        let substackNode = currentNode.inputs?.substack;
        
        // Recursively collect all blocks in the substack
        while (substackNode) {
            yesCommands.push({
                opcode: substackNode.opcode,
                arguments: getParamsByMotionType(substackNode, blocksMap)
            });
            substackNode = substackNode.next;
        }
        
        // 获取CONDITION输入的值（支持嵌套积木）
        const conditionValue = getInputValue('CONDITION');
        
        return {
            conditionType: currentNode.fields?.condition_type?.value || 'satisfy', // 满足条件/不满足条件
            condition: conditionValue,  // 支持嵌套积木的条件值
            yes: yesCommands,
            no: [],
        };
    } else if (type === "event_detect_cliff") {
        const yesCommands = [];
        let substackNode = currentNode.inputs?.substack;
        
        // Recursively collect all blocks in the substack
        while (substackNode) {
            yesCommands.push({
                opcode: substackNode.opcode,
                arguments: getParamsByMotionType(substackNode)
            });
            substackNode = substackNode.next;
        }
        
        return {
            yes: yesCommands,
            no: [],
        };
    } else if (type === "event_back_detect_cliff") {
        const yesCommands = [];
        let substackNode = currentNode.inputs?.substack;
        
        // Recursively collect all blocks in the substack
        while (substackNode) {
            yesCommands.push({
                opcode: substackNode.opcode,
                arguments: getParamsByMotionType(substackNode)
            });
            substackNode = substackNode.next;
        }
        
        return {
            yes: yesCommands,
            no: [],
        };
    }

    let ret = {};
    for (const key in currentNode.inputs) {
        for (const key2 in currentNode.inputs[key].fields) {
            if (currentNode.inputs[key].fields[key2]?.value !== undefined) {
                ret[key] = currentNode.inputs[key].fields[key2].value;
            }
        }
    }

    // console.log("其他积木开发中");
    // message.warning("其他积木开发中");
    return ret;
};

export function buildBlockTree(blocksArray) {
    // 先将数组转为 id->block 的映射，方便查找
    const blocksMap = {};
    blocksArray.forEach((block) => {
        blocksMap[block.id] = block;
    });

    // 递归构建积木树
    function buildTree(block) {
        const result = {
            id: block.id,
            opcode: block.opcode,
            fields: block.fields,
            shadow: block.shadow,
            topLevel: block.topLevel,
            x: block.x,
            y: block.y,
            inputs: {},
            next: null,
        };
        // 处理 inputs
        for (const key in block.inputs) {
            const inputInfo = block.inputs[key];
            // console.log("inputInfo", inputInfo);

            if (inputInfo.block && blocksMap[inputInfo.block]) {
                result.inputs[key] = buildTree(blocksMap[inputInfo.block]);
            }
        }
        // 处理 next
        if (block.next && blocksMap[block.next]) {
            result.next = buildTree(blocksMap[block.next]);
        }
        return result;
    }

    // 找到所有顶层积木块
    const topBlocks = blocksArray.filter((block) => block.topLevel);
    // 构建每个顶层积木块的树
    return topBlocks.map(buildTree);
}

/**
 * @description 将通过 'next' 属性链接的 JSON 对象数组扁平化
 * @param {Array<Object>} jsonArray 包含一个或多个根节点的数组
 * @returns {Array<Object>} 只包含 opcode 和 inputs 字段的扁平化数组
 */
export function flattenJsonByNext(jsonArray) {
    const flattenedArray = [];
    
    // 收集所有已经在 inputs 中的积木 ID，这些不应该被当作顶级积木
    const nestedBlockIds = new Set();
    const collectNestedIds = (node) => {
        if (!node) return;
        
        // 收集 inputs 中的嵌套积木 ID
        if (node.inputs) {
            for (const key in node.inputs) {
                const input = node.inputs[key];
                if (input && typeof input === 'object') {
                    if (input.id) {
                        nestedBlockIds.add(input.id);
                    }
                    // 递归收集更深层的嵌套积木
                    collectNestedIds(input);
                }
            }
        }
        
        // 收集 next 链中的积木 ID
        if (node.next) {
            collectNestedIds(node.next);
        }
    };
    
    // 遍历所有根节点，收集所有嵌套积木的 ID
    for (const rootNode of jsonArray) {
        collectNestedIds(rootNode);
    }
    
    console.log("[DEBUG] 嵌套积木 IDs:", nestedBlockIds);
    console.log("[DEBUG] 原始顶级积木数量:", jsonArray.length);
    console.log("[DEBUG] 原始顶级积木 IDs:", jsonArray.map(n => n.id));

    // 过滤掉已经在 inputs 中的积木，只保留真正的顶级积木
    const realTopLevelBlocks = jsonArray.filter(node => {
        const isNested = nestedBlockIds.has(node.id);
        if (isNested) {
            console.log(`[DEBUG] 过滤掉嵌套积木: ${node.opcode} (ID: ${node.id})`);
        }
        return !isNested;
    });
    console.log("[DEBUG] 过滤后的顶级积木数量:", realTopLevelBlocks.length);
    console.log("[DEBUG] 过滤后的顶级积木:", realTopLevelBlocks.map(n => `${n.opcode} (ID: ${n.id})`));

    // 遍历真正的顶级积木
    for (const rootNode of realTopLevelBlocks) {
        let currentNode = rootNode;

        // 当 currentNode 不为 null 时，持续遍历链表
        while (currentNode) {
            // 过滤掉 shadow 积木（空的占位符积木）
            if (currentNode.shadow) {
                console.log(`[DEBUG] 过滤掉 shadow 积木: ${currentNode.opcode} (ID: ${currentNode.id})`);
                currentNode = currentNode.next;
                continue;
            }
            
            // 打印每个积木的详细信息
            console.log(`[DEBUG] 处理积木: ${currentNode.opcode} (ID: ${currentNode.id})`, {
                inputs: currentNode.inputs,
                fields: currentNode.fields,
                shadow: currentNode.shadow
            });
            
            // 过滤掉没有实际内容的 math_number 积木
            const isEmptyMathNumber = currentNode.opcode === 'math_number' && 
                                     (!currentNode.inputs || Object.keys(currentNode.inputs).length === 0) &&
                                     (!currentNode.fields || Object.keys(currentNode.fields).length === 0);
            
            console.log(`[DEBUG] isEmptyMathNumber: ${isEmptyMathNumber}`);
            
            if (!isEmptyMathNumber) {
                // 提取需要的字段并添加到结果数组中
                flattenedArray.push({
                    opcode: currentNode.opcode,
                    inputs: getParamsByMotionType(currentNode),
                });
            } else {
                console.log(`[DEBUG] 过滤掉空的 math_number 积木 (ID: ${currentNode.id})`);
            }

            // 移动到下一个节点
            currentNode = currentNode.next;
        }
    }

    return flattenedArray;
}

export function filterBlocks(xmlString, allowedTypes) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");

    const category = xmlDoc.querySelector("category");
    const blocks = category.querySelectorAll("block");

    blocks.forEach((block) => {
        const type = block.getAttribute("type");
        if (!allowedTypes.includes(type)) {
            block.remove();
        }
    });

    const newBlocks = category.querySelectorAll("block");

    // 返回处理后的 XML 字符串
    const serializer = new XMLSerializer();
    return {
        xml: serializer.serializeToString(category),
        blockLen: newBlocks?.length || 0,
    };
}

/**
 * 递归地将对象或数组中所有纯数字字符串的值转换为数字。
 * @param {any} data - 输入的数据，可以是任何类型。
 * @returns {any} - 返回处理后的新数据。
 */
export function convertNumericStringsToNumbers(data) {
    // 1. 基本类型或null，直接返回，这是递归的出口
    if (typeof data !== "object" || data === null) {
        return data;
    }

    // 2. 如果是数组，则遍历每个元素并递归处理
    if (Array.isArray(data)) {
        return data.map((item) => convertNumericStringsToNumbers(item));
    }

    // 3. 如果是对象，则遍历每个键值对
    const newObj = {};
    for (const key in data) {
        // 确保只处理对象自身的属性
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            const value = data[key];

            // 检查值是否为纯数字字符串
            // 正则表达式 ^\d+$ 表示：从开头(^)到结尾($)都必须是数字(\d)
            // + 表示一个或多个数字，这样可以排除空字符串''
            if (typeof value === "string" && /^\d+$/.test(value)) {
                // 如果是，转换为数字
                newObj[key] = Number(value);
            } else {
                // 如果不是，递归处理（因为值可能是另一个对象或数组）
                newObj[key] = convertNumericStringsToNumbers(value);
            }
        }
    }

    return newObj;
}
